/**
 * SS-3191: Reports › Campaigns. The classic report (CampaignReport) stays the default view; a
 * button switches to the new per-campaign report with goals and a button there switches back.
 * Every visit opens on the classic report; ?view=new opens the new one directly (the new report's
 * detail pages link back to it).
 */
import React from "react";
import { Button, Flex } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";

import CampaignReport from "../CampaignReport";
import OutreachReportList from "./OutreachReportList";
import { isNewView } from "./outreachReportUtils";

function CampaignReportSwitch(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const switchTo = (view) => {
    const params = new URLSearchParams(location.search);
    if (view === "new") params.set("view", "new");
    else params.delete("view");
    const search = params.toString();
    navigate({ pathname: location.pathname, search: search ? `?${search}` : "" });
  };

  if (isNewView(location.search)) {
    return <OutreachReportList onShowClassic={() => switchTo("classic")} />;
  }
  return (
    <>
      <Flex justify="flex-end" px={4} pt={4}>
        <Button size="sm" colorScheme="blue" variant="outline" onClick={() => switchTo("new")}>
          Show the new report
        </Button>
      </Flex>
      <CampaignReport {...props} />
    </>
  );
}

export default CampaignReportSwitch;
